import { useResolutionsContext } from "../hooks/useResolutionsContext";
import { Box, Typography } from '@mui/material';

//This component is responsible for rendering the resolution event title.
export default function ResolutionsEventTitle() {
  const { selectedEvent } = useResolutionsContext();
  return (
    <Box>
      <Typography variant="h4" component="div" sx={{ paddingTop: 2 }}>
        <Box sx={{ fontWeight: 'bold' }}>{selectedEvent?.Name}</Box>
      </Typography>
    </Box>
  );
}